


















































































import { Component, Vue, Watch } from "vue-property-decorator";
import loader from "@/components/loader.vue";

import { momentTZ as moment } from "@/helpers/moment";
import billingApi from "@/services/billing";
import { debounce, cancel } from "typescript-debounce-decorator";
import { Action, Getter, Mutation } from "vuex-class";
import { WarehousePackage } from "@/models/warehousePackage";

import { NSLog } from "@/helpers/log";
import {
  edit as EditPackage,
  disable as DisablePackage,
} from "@/dialogs/package";
import { Package } from "@/models/package";
import { Warehouse } from "@/models/warehouse";
import billing from "@/services/billing";
import { PackageGroup } from "@/models/packagegroup";
import ProductIcon from "@/components/ProductIcon.vue";
const log = NSLog("view/ManagePackages");

@Component({
  components: {
    loader,
    EditPackage,
    DisablePackage,
    ProductIcon,
  },
})
export default class ManagePackages extends Vue {
  private get visiblePackages() {
    if (this.onlyVisible) {
      return this.packages.filter(
        (p: Package) => p.is_visible_state !== "Expired"
      );
    }
    return this.packages;
  }

  @Getter("warehouses") warehouses!: Warehouse[];

  get availablePackages() {
    return this.visiblePackages
      .sort((a, b) => (a.code > b.code ? 1 : -1))
      .map((p: Package | any) => {
        p._ssCode = p._ssCode || p.code.substr(0, 10);
        p._wh_enabled = {};
        for (const wh of this.warehouses) {
          p._wh_enabled[wh.id] = this.isEnabled(wh.id, p._ssCode);
        }
        return p;
      });
  }

  private get packagesGroupedByPackageGroup() {
    const pgs: any = {};
    this.visiblePackages.map((p: Package | any) => {
      p._ssCode = p._ssCode || p.code.substr(0, 10);
      p._changed = p._changed || false;
      p._newPrice = p._newPrice || false;
      pgs[p.package_group_id] = pgs[p.package_group_id] || [];
      pgs[p.package_group_id].push(p);
    });

    return this.packageGroups
      .sort((a: PackageGroup, b: PackageGroup) => (a.title > b.title ? 1 : -1))
      .map((pg: PackageGroup) => ({
        _changed: false,
        id: pg.id,
        title: pg.title,
        packages: pgs[pg.group] || [],
      }));
  }

  private get packagesGroupedByPackageGroupAndSSCode() {
    const groups: any = [];

    // loop package groups
    for (const groupID of Object.keys(this.packagesGroupedByPackageGroup)) {
      const group = this.packagesGroupedByPackageGroup[groupID];
      if (!group.packages.length) {
        groups.push(group);
        continue;
      }

      // create sscode grouping
      const groupSSCodes: any = {};
      group.packages.map((pkg: any) => {
        groupSSCodes[pkg._ssCode] = groupSSCodes[pkg._ssCode] || [];
        groupSSCodes[pkg._ssCode].push(pkg);
      });

      // reset group packages
      group.packages = [];

      // loop over sscodes to create packages
      for (const ssCode of Object.keys(groupSSCodes)) {
        const pkgs = groupSSCodes[ssCode];
        group.packages.push({
          _ssCode: ssCode,
          code: ssCode,
          packages: pkgs,
          title: this.uniqueProps(pkgs, "title").join("<br/>"),
          _OZARPkg: pkgs.find(
            (p: Package) => p.interval === "once" && p.currency === "ZAR"
          ),
          _OUSDPkg: pkgs.find(
            (p: Package) => p.interval === "once" && p.currency === "USD"
          ),
          _MZARPkg: pkgs.find(
            (p: Package) => p.interval === "month" && p.currency === "ZAR"
          ),
          _YZARPkg: pkgs.find(
            (p: Package) => p.interval === "year" && p.currency === "ZAR"
          ),
          _MUSDPkg: pkgs.find(
            (p: Package) => p.interval === "month" && p.currency === "USD"
          ),
          _YUSDPkg: pkgs.find(
            (p: Package) => p.interval === "year" && p.currency === "USD"
          ),
        });
      }
      groups.push(group);
    }
    return groups;
  }

  public get categories() {
    return this.packages.map((p: Package) => p.category);
  }
  public packages: Package[] = [];

  @Getter("packageGroups") public packageGroups: any;
  @Mutation("setLastErr") public setLastErr: any;

  get headers() {
    const hdrs: any = [
      { text: "Code", value: "code" },
      {
        text: "Title",
        align: "left",
        sortable: true,
        value: "title",
      },
      { text: "Interval", value: "interval" },
      { text: "Price", value: "price" },
      { text: "Currency", value: "currency" },
      // // { text: "Expiry", value: "expiry" },
      // { text: "Updated", value: "updated_at" },
    ];
    for (const wh of this.warehouses) {
      hdrs.push({
        text: wh.name,
        value: "",
        sortable: false,
        width: "20px",
      });
    }
    return hdrs;
  }

  // @debounce(500, { leading: true })
  private async toggleWarehousePackage(
    whID: number,
    ssCode: string,
    enabled: any
  ) {
    this.saving = true;
    try {
      await billingApi.toggleWarehousePackage(whID, ssCode, enabled);
    } catch (err) {
    }
    this.saving = false;
  }

  @Getter("warehousepackages") warehousepackages!: WarehousePackage[];
  private isEnabled(warehouseID: number, ssCode: string) {
    return this.warehousepackages.find(
      (wp) => wp.warehouse_id == warehouseID && wp.short_code == ssCode
    )
      ? true
      : false;
  }

  private loading = false;
  private saving = false;
  private onlyVisible = true;

  private pagination: any = {
    // descending: boolean",
    // page: number",
    rowsPerPage: -1,
    sortBy: "_ssCode",
    // totalItems: number"
  };

  private editPackage: Package | boolean = false;
  private disablePackage: Package | boolean = false;
  public getGroupPackages(groupID: number) {
    return this.visiblePackages.filter(
      (p: Package) => p.package_group_id === groupID
    );
  }

  public created() {
    this.refreshPackages();
  }

  private uniqueProps(items: any[], prop: string) {
    const unique: any[] = [];
    items.map((it: any) => {
      if (!unique.find((existing: any) => existing === it[prop])) {
        unique.push(it[prop]);
      }
    });
    return unique;
  }

  private async refreshPackages() {
    this.loading = true;
    try {
      this.packages = await billingApi.listPackages();
    } catch (err) {
      log("err", err);
    }
    this.loading = false;
  }
}
